import ApiService from './api.service';

export default {
  /**
   * Upload a single image
   * @param {File} file - The file to upload
   * @returns {Promise} - API response
   */
  uploadImage(file) {
    const formData = new FormData();
    formData.append('file', file);

    return ApiService.post('/v1/images/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  /**
   * Get all images
   * @returns {Promise} - API response
   */
  getAllImages() {
    return ApiService.get('/v1/images');
  },

  /**
   * Get image by ID
   * @param {string} id - Image ID
   * @returns {Promise} - API response
   */
  getImageById(id) {
    return ApiService.get(`/v1/images/${id}`);
  },

  /**
   * Delete image by ID
   * @param {string} id - Image ID
   * @returns {Promise} - API response
   */
  deleteImage(id) {
    console.log('delete image', id);
    return ApiService.delete(`/v1/images/${id}`);
  },

  /**
   * Check image status
   * @param {string} id - Image ID
   * @returns {Promise} - API response
   */
  checkImageStatus(id) {
    return ApiService.get(`/v1/images/${id}/status`);
  },

  /**
   * Get image usages
   * @param {string} id - Image ID
   * @returns {Promise} - API response
   */
  getImageUsages(id) {
    return ApiService.get(`/v1/asset-usages/assets/${id}/usages`);
  },
};
